var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMinnesota(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.19,
    height: 165.498,
    viewBox: "0 0 146.19 165.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__icon_minnesota"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2606",
    d: "M14.847 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2606",
    transform: "translate(-10.25 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2607",
    d: "M14.847 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2607",
    transform: "translate(-10.25 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2608",
    d: "M14.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2608",
    transform: "translate(-10.25 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2609",
    d: "M14.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2609",
    transform: "translate(-10.25 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2610",
    d: "M14.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2610",
    transform: "translate(-10.25 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2611",
    d: "M14.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2611",
    transform: "translate(-10.25 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2612",
    d: "M18.347 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2612",
    transform: "translate(-7.314 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2613",
    d: "M18.347 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2613",
    transform: "translate(-7.314 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2614",
    d: "M18.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2614",
    transform: "translate(-7.314 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2615",
    d: "M18.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2615",
    transform: "translate(-7.314 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2616",
    d: "M18.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2616",
    transform: "translate(-7.314 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2617",
    d: "M18.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2617",
    transform: "translate(-7.314 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2618",
    d: "M18.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2618",
    transform: "translate(-7.314 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2619",
    d: "M18.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2619",
    transform: "translate(-7.314 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2620",
    d: "M18.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2620",
    transform: "translate(-7.314 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2621",
    d: "M18.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2621",
    transform: "translate(-7.314 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2622",
    d: "M18.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2622",
    transform: "translate(-7.314 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2623",
    d: "M18.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2623",
    transform: "translate(-7.314 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2624",
    d: "M18.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2624",
    transform: "translate(-7.314 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2625",
    d: "M18.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2625",
    transform: "translate(-7.314 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2626",
    d: "M18.347 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2626",
    transform: "translate(-7.314 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2627",
    d: "M18.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2627",
    transform: "translate(-7.314 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2628",
    d: "M21.847 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2628",
    transform: "translate(-4.378 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2629",
    d: "M21.847 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2629",
    transform: "translate(-4.378 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2630",
    d: "M21.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2630",
    transform: "translate(-4.378 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2631",
    d: "M21.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2631",
    transform: "translate(-4.378 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2632",
    d: "M21.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2632",
    transform: "translate(-4.378 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2633",
    d: "M21.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2633",
    transform: "translate(-4.378 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2634",
    d: "M21.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2634",
    transform: "translate(-4.378 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2635",
    d: "M21.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2635",
    transform: "translate(-4.378 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2636",
    d: "M21.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2636",
    transform: "translate(-4.378 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2637",
    d: "M21.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2637",
    transform: "translate(-4.378 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2638",
    d: "M21.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2638",
    transform: "translate(-4.378 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2639",
    d: "M21.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2639",
    transform: "translate(-4.378 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2640",
    d: "M21.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2640",
    transform: "translate(-4.378 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2641",
    d: "M21.847 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2641",
    transform: "translate(-4.378 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2642",
    d: "M21.847 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2642",
    transform: "translate(-4.378 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2643",
    d: "M21.847 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2643",
    transform: "translate(-4.378 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2644",
    d: "M21.847 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2644",
    transform: "translate(-4.378 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2645",
    d: "M21.847 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2645",
    transform: "translate(-4.378 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2646",
    d: "M21.847 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2646",
    transform: "translate(-4.378 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2647",
    d: "M21.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2647",
    transform: "translate(-4.378 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2648",
    d: "M21.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2648",
    transform: "translate(-4.378 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2649",
    d: "M21.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2649",
    transform: "translate(-4.378 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2650",
    d: "M21.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2650",
    transform: "translate(-4.378 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2651",
    d: "M21.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2651",
    transform: "translate(-4.378 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2652",
    d: "M25.347 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2652",
    transform: "translate(-1.442 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2653",
    d: "M25.347 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2653",
    transform: "translate(-1.442 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2654",
    d: "M25.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2654",
    transform: "translate(-1.442 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2655",
    d: "M25.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2655",
    transform: "translate(-1.442 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2656",
    d: "M25.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2656",
    transform: "translate(-1.442 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2657",
    d: "M25.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2657",
    transform: "translate(-1.442 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2658",
    d: "M25.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2658",
    transform: "translate(-1.442 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2659",
    d: "M25.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2659",
    transform: "translate(-1.442 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2660",
    d: "M25.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2660",
    transform: "translate(-1.442 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2661",
    d: "M25.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2661",
    transform: "translate(-1.442 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2662",
    d: "M25.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2662",
    transform: "translate(-1.442 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2663",
    d: "M25.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2663",
    transform: "translate(-1.442 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2664",
    d: "M25.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2664",
    transform: "translate(-1.442 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2665",
    d: "M25.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2665",
    transform: "translate(-1.442 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2666",
    d: "M25.347 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2666",
    transform: "translate(-1.442 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2667",
    d: "M25.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2667",
    transform: "translate(-1.442 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2668",
    d: "M25.347 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2668",
    transform: "translate(-1.442 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2669",
    d: "M25.347 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2669",
    transform: "translate(-1.442 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2670",
    d: "M25.347 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2670",
    transform: "translate(-1.442 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2671",
    d: "M25.347 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2671",
    transform: "translate(-1.442 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2672",
    d: "M25.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2672",
    transform: "translate(-1.442 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2673",
    d: "M25.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2673",
    transform: "translate(-1.442 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2674",
    d: "M25.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2674",
    transform: "translate(-1.442 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2675",
    d: "M25.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2675",
    transform: "translate(-1.442 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2676",
    d: "M28.847 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2676",
    transform: "translate(1.495 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2677",
    d: "M28.847 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2677",
    transform: "translate(1.495 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2678",
    d: "M28.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2678",
    transform: "translate(1.495 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2679",
    d: "M28.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2679",
    transform: "translate(1.495 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2680",
    d: "M28.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2680",
    transform: "translate(1.495 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2681",
    d: "M28.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2681",
    transform: "translate(1.495 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2682",
    d: "M28.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2682",
    transform: "translate(1.495 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2683",
    d: "M28.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2683",
    transform: "translate(1.495 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2684",
    d: "M28.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2684",
    transform: "translate(1.495 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2685",
    d: "M28.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2685",
    transform: "translate(1.495 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2686",
    d: "M28.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2686",
    transform: "translate(1.495 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2687",
    d: "M28.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2687",
    transform: "translate(1.495 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2688",
    d: "M28.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2688",
    transform: "translate(1.495 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2689",
    d: "M28.847 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2689",
    transform: "translate(1.495 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2690",
    d: "M28.847 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2690",
    transform: "translate(1.495 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2691",
    d: "M28.847 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2691",
    transform: "translate(1.495 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2692",
    d: "M28.847 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2692",
    transform: "translate(1.495 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2693",
    d: "M28.847 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2693",
    transform: "translate(1.495 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2694",
    d: "M28.847 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2694",
    transform: "translate(1.495 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2695",
    d: "M28.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2695",
    transform: "translate(1.495 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2696",
    d: "M28.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2696",
    transform: "translate(1.495 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2697",
    d: "M28.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2697",
    transform: "translate(1.495 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2698",
    d: "M28.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2698",
    transform: "translate(1.495 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2699",
    d: "M28.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2699",
    transform: "translate(1.495 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2700",
    d: "M32.347 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2700",
    transform: "translate(4.431 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2701",
    d: "M32.347 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2701",
    transform: "translate(4.431 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2702",
    d: "M32.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2702",
    transform: "translate(4.431 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2703",
    d: "M32.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2703",
    transform: "translate(4.431 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2704",
    d: "M32.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2704",
    transform: "translate(4.431 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2705",
    d: "M32.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2705",
    transform: "translate(4.431 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2706",
    d: "M32.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2706",
    transform: "translate(4.431 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2707",
    d: "M32.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2707",
    transform: "translate(4.431 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2708",
    d: "M32.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2708",
    transform: "translate(4.431 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2709",
    d: "M32.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2709",
    transform: "translate(4.431 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2710",
    d: "M32.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2710",
    transform: "translate(4.431 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2711",
    d: "M32.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2711",
    transform: "translate(4.431 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2712",
    d: "M32.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2712",
    transform: "translate(4.431 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2713",
    d: "M32.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2713",
    transform: "translate(4.431 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2714",
    d: "M32.347 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2714",
    transform: "translate(4.431 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2715",
    d: "M32.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2715",
    transform: "translate(4.431 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2716",
    d: "M32.347 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2716",
    transform: "translate(4.431 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2717",
    d: "M32.347 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2717",
    transform: "translate(4.431 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2718",
    d: "M32.347 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2718",
    transform: "translate(4.431 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2719",
    d: "M32.347 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2719",
    transform: "translate(4.431 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2720",
    d: "M32.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2720",
    transform: "translate(4.431 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2721",
    d: "M32.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2721",
    transform: "translate(4.431 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2722",
    d: "M32.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2722",
    transform: "translate(4.431 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2723",
    d: "M32.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2723",
    transform: "translate(4.431 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2724",
    d: "M35.847 959.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2724",
    transform: "translate(7.367 -957.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2725",
    d: "M35.847 963.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2725",
    transform: "translate(7.367 -954.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2726",
    d: "M35.847 966.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2726",
    transform: "translate(7.367 -951.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2727",
    d: "M35.847 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2727",
    transform: "translate(7.367 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2728",
    d: "M35.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2728",
    transform: "translate(7.367 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2729",
    d: "M35.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2729",
    transform: "translate(7.367 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2730",
    d: "M35.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2730",
    transform: "translate(7.367 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2731",
    d: "M35.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2731",
    transform: "translate(7.367 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2732",
    d: "M35.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2732",
    transform: "translate(7.367 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2733",
    d: "M35.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2733",
    transform: "translate(7.367 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2734",
    d: "M35.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2734",
    transform: "translate(7.367 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2735",
    d: "M35.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2735",
    transform: "translate(7.367 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2736",
    d: "M35.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2736",
    transform: "translate(7.367 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2737",
    d: "M35.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2737",
    transform: "translate(7.367 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2738",
    d: "M35.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2738",
    transform: "translate(7.367 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2739",
    d: "M35.847 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2739",
    transform: "translate(7.367 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2740",
    d: "M35.847 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2740",
    transform: "translate(7.367 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2741",
    d: "M35.847 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2741",
    transform: "translate(7.367 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2742",
    d: "M35.847 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2742",
    transform: "translate(7.367 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2743",
    d: "M35.847 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2743",
    transform: "translate(7.367 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2744",
    d: "M35.847 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2744",
    transform: "translate(7.367 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2745",
    d: "M35.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2745",
    transform: "translate(7.367 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2746",
    d: "M35.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2746",
    transform: "translate(7.367 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2747",
    d: "M35.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2747",
    transform: "translate(7.367 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2748",
    d: "M35.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2748",
    transform: "translate(7.367 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2749",
    d: "M35.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2749",
    transform: "translate(7.367 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2750",
    d: "M39.347 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2750",
    transform: "translate(10.303 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2751",
    d: "M39.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2751",
    transform: "translate(10.303 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2752",
    d: "M39.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2752",
    transform: "translate(10.303 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2753",
    d: "M39.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2753",
    transform: "translate(10.303 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2754",
    d: "M39.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2754",
    transform: "translate(10.303 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2755",
    d: "M39.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2755",
    transform: "translate(10.303 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2756",
    d: "M39.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2756",
    transform: "translate(10.303 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2757",
    d: "M39.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2757",
    transform: "translate(10.303 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2758",
    d: "M39.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2758",
    transform: "translate(10.303 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2759",
    d: "M39.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2759",
    transform: "translate(10.303 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2760",
    d: "M39.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2760",
    transform: "translate(10.303 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2761",
    d: "M39.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2761",
    transform: "translate(10.303 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2762",
    d: "M39.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2762",
    transform: "translate(10.303 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2763",
    d: "M39.347 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2763",
    transform: "translate(10.303 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2764",
    d: "M39.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2764",
    transform: "translate(10.303 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2765",
    d: "M39.347 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2765",
    transform: "translate(10.303 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2766",
    d: "M39.347 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2766",
    transform: "translate(10.303 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2767",
    d: "M39.347 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2767",
    transform: "translate(10.303 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2768",
    d: "M39.347 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2768",
    transform: "translate(10.303 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2769",
    d: "M39.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2769",
    transform: "translate(10.303 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2770",
    d: "M39.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2770",
    transform: "translate(10.303 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2771",
    d: "M39.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2771",
    transform: "translate(10.303 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2772",
    d: "M39.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2772",
    transform: "translate(10.303 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2773",
    d: "M42.847 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2773",
    transform: "translate(13.239 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2774",
    d: "M42.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2774",
    transform: "translate(13.239 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2775",
    d: "M42.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2775",
    transform: "translate(13.239 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2776",
    d: "M42.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2776",
    transform: "translate(13.239 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2777",
    d: "M42.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2777",
    transform: "translate(13.239 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2778",
    d: "M42.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2778",
    transform: "translate(13.239 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2779",
    d: "M42.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2779",
    transform: "translate(13.239 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2780",
    d: "M42.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2780",
    transform: "translate(13.239 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2781",
    d: "M42.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2781",
    transform: "translate(13.239 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2782",
    d: "M42.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2782",
    transform: "translate(13.239 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2783",
    d: "M42.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2783",
    transform: "translate(13.239 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2784",
    d: "M42.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2784",
    transform: "translate(13.239 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2785",
    d: "M42.847 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2785",
    transform: "translate(13.239 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2786",
    d: "M42.847 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2786",
    transform: "translate(13.239 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2787",
    d: "M42.847 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2787",
    transform: "translate(13.239 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2788",
    d: "M42.847 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2788",
    transform: "translate(13.239 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2789",
    d: "M42.847 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2789",
    transform: "translate(13.239 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2790",
    d: "M42.847 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2790",
    transform: "translate(13.239 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2791",
    d: "M42.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2791",
    transform: "translate(13.239 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2792",
    d: "M42.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2792",
    transform: "translate(13.239 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2793",
    d: "M42.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2793",
    transform: "translate(13.239 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2794",
    d: "M42.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2794",
    transform: "translate(13.239 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2795",
    d: "M42.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2795",
    transform: "translate(13.239 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2796",
    d: "M46.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2796",
    transform: "translate(16.175 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2797",
    d: "M46.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2797",
    transform: "translate(16.175 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2798",
    d: "M46.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2798",
    transform: "translate(16.175 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2799",
    d: "M46.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2799",
    transform: "translate(16.175 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2800",
    d: "M46.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2800",
    transform: "translate(16.175 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2801",
    d: "M46.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2801",
    transform: "translate(16.175 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2802",
    d: "M46.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2802",
    transform: "translate(16.175 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2803",
    d: "M46.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2803",
    transform: "translate(16.175 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2804",
    d: "M46.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2804",
    transform: "translate(16.175 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2805",
    d: "M46.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2805",
    transform: "translate(16.175 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2806",
    d: "M46.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2806",
    transform: "translate(16.175 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2807",
    d: "M46.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2807",
    transform: "translate(16.175 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2808",
    d: "M46.347 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2808",
    transform: "translate(16.175 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2809",
    d: "M46.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2809",
    transform: "translate(16.175 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2810",
    d: "M46.347 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2810",
    transform: "translate(16.175 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2811",
    d: "M46.347 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2811",
    transform: "translate(16.175 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2812",
    d: "M46.347 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2812",
    transform: "translate(16.175 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2813",
    d: "M46.347 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2813",
    transform: "translate(16.175 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2814",
    d: "M46.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2814",
    transform: "translate(16.175 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2815",
    d: "M46.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2815",
    transform: "translate(16.175 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2816",
    d: "M46.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2816",
    transform: "translate(16.175 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2817",
    d: "M46.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2817",
    transform: "translate(16.175 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2818",
    d: "M49.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2818",
    transform: "translate(19.111 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2819",
    d: "M49.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2819",
    transform: "translate(19.111 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2820",
    d: "M49.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2820",
    transform: "translate(19.111 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2821",
    d: "M49.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2821",
    transform: "translate(19.111 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2822",
    d: "M49.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2822",
    transform: "translate(19.111 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2823",
    d: "M49.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2823",
    transform: "translate(19.111 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2824",
    d: "M49.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2824",
    transform: "translate(19.111 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2825",
    d: "M49.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2825",
    transform: "translate(19.111 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2826",
    d: "M49.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2826",
    transform: "translate(19.111 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2827",
    d: "M49.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2827",
    transform: "translate(19.111 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2828",
    d: "M49.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2828",
    transform: "translate(19.111 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2829",
    d: "M49.847 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2829",
    transform: "translate(19.111 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2830",
    d: "M49.847 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2830",
    transform: "translate(19.111 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2831",
    d: "M49.847 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2831",
    transform: "translate(19.111 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2832",
    d: "M49.847 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2832",
    transform: "translate(19.111 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2833",
    d: "M49.847 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2833",
    transform: "translate(19.111 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2834",
    d: "M49.847 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2834",
    transform: "translate(19.111 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2835",
    d: "M49.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2835",
    transform: "translate(19.111 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2836",
    d: "M49.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2836",
    transform: "translate(19.111 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2837",
    d: "M49.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2837",
    transform: "translate(19.111 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2838",
    d: "M49.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2838",
    transform: "translate(19.111 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2839",
    d: "M49.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2839",
    transform: "translate(19.111 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2840",
    d: "M53.347 970.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2840",
    transform: "translate(22.047 -948.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2841",
    d: "M53.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2841",
    transform: "translate(22.047 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2842",
    d: "M53.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2842",
    transform: "translate(22.047 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2843",
    d: "M53.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2843",
    transform: "translate(22.047 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2844",
    d: "M53.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2844",
    transform: "translate(22.047 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2845",
    d: "M53.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2845",
    transform: "translate(22.047 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2846",
    d: "M53.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2846",
    transform: "translate(22.047 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2847",
    d: "M53.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2847",
    transform: "translate(22.047 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2848",
    d: "M53.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2848",
    transform: "translate(22.047 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2849",
    d: "M53.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2849",
    transform: "translate(22.047 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2850",
    d: "M53.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2850",
    transform: "translate(22.047 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2851",
    d: "M53.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2851",
    transform: "translate(22.047 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2852",
    d: "M53.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2852",
    transform: "translate(22.047 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2853",
    d: "M53.347 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2853",
    transform: "translate(22.047 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2854",
    d: "M53.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2854",
    transform: "translate(22.047 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2855",
    d: "M53.347 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2855",
    transform: "translate(22.047 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2856",
    d: "M53.347 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2856",
    transform: "translate(22.047 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2857",
    d: "M53.347 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2857",
    transform: "translate(22.047 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2858",
    d: "M53.347 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2858",
    transform: "translate(22.047 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2859",
    d: "M53.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2859",
    transform: "translate(22.047 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2860",
    d: "M53.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2860",
    transform: "translate(22.047 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2861",
    d: "M53.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2861",
    transform: "translate(22.047 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2862",
    d: "M53.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2862",
    transform: "translate(22.047 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2863",
    d: "M56.847 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2863",
    transform: "translate(24.983 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2864",
    d: "M56.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2864",
    transform: "translate(24.983 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2865",
    d: "M56.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2865",
    transform: "translate(24.983 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2866",
    d: "M56.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2866",
    transform: "translate(24.983 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2867",
    d: "M56.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2867",
    transform: "translate(24.983 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2868",
    d: "M56.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2868",
    transform: "translate(24.983 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2869",
    d: "M56.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2869",
    transform: "translate(24.983 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2870",
    d: "M56.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2870",
    transform: "translate(24.983 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2871",
    d: "M56.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2871",
    transform: "translate(24.983 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2872",
    d: "M56.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2872",
    transform: "translate(24.983 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2873",
    d: "M56.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2873",
    transform: "translate(24.983 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2874",
    d: "M56.847 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2874",
    transform: "translate(24.983 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2875",
    d: "M56.847 1015.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2875",
    transform: "translate(24.983 -910.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2876",
    d: "M56.847 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2876",
    transform: "translate(24.983 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2877",
    d: "M56.847 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2877",
    transform: "translate(24.983 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2878",
    d: "M56.847 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2878",
    transform: "translate(24.983 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2879",
    d: "M56.847 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2879",
    transform: "translate(24.983 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2880",
    d: "M56.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2880",
    transform: "translate(24.983 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2881",
    d: "M56.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2881",
    transform: "translate(24.983 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2882",
    d: "M56.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2882",
    transform: "translate(24.983 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2883",
    d: "M56.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2883",
    transform: "translate(24.983 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2884",
    d: "M56.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2884",
    transform: "translate(24.983 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2885",
    d: "M60.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2885",
    transform: "translate(27.919 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2886",
    d: "M60.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2886",
    transform: "translate(27.919 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2887",
    d: "M60.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2887",
    transform: "translate(27.919 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2888",
    d: "M60.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2888",
    transform: "translate(27.919 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2889",
    d: "M60.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2889",
    transform: "translate(27.919 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2890",
    d: "M60.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2890",
    transform: "translate(27.919 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2891",
    d: "M60.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2891",
    transform: "translate(27.919 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2892",
    d: "M60.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2892",
    transform: "translate(27.919 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2893",
    d: "M60.347 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2893",
    transform: "translate(27.919 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2894",
    d: "M60.347 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2894",
    transform: "translate(27.919 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2895",
    d: "M60.347 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2895",
    transform: "translate(27.919 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2896",
    d: "M60.347 1012.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2896",
    transform: "translate(27.919 -913.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2897",
    d: "M60.347 1019.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2897",
    transform: "translate(27.919 -907.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2898",
    d: "M60.347 1022.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2898",
    transform: "translate(27.919 -904.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2899",
    d: "M60.347 1026.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2899",
    transform: "translate(27.919 -901.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2900",
    d: "M60.347 1029.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2900",
    transform: "translate(27.919 -898.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2901",
    d: "M60.347 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2901",
    transform: "translate(27.919 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2902",
    d: "M60.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2902",
    transform: "translate(27.919 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2903",
    d: "M60.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2903",
    transform: "translate(27.919 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2904",
    d: "M60.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2904",
    transform: "translate(27.919 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2905",
    d: "M60.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2905",
    transform: "translate(27.919 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2906",
    d: "M63.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2906",
    transform: "translate(30.855 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2907",
    d: "M63.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2907",
    transform: "translate(30.855 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2908",
    d: "M63.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2908",
    transform: "translate(30.855 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2909",
    d: "M63.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2909",
    transform: "translate(30.855 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2910",
    d: "M63.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2910",
    transform: "translate(30.855 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2911",
    d: "M63.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2911",
    transform: "translate(30.855 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2912",
    d: "M63.847 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2912",
    transform: "translate(30.855 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2913",
    d: "M63.847 1001.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2913",
    transform: "translate(30.855 -922.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2914",
    d: "M63.847 1005.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2914",
    transform: "translate(30.855 -919.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2915",
    d: "M63.847 1008.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2915",
    transform: "translate(30.855 -916.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2916",
    d: "M63.847 1033.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2916",
    transform: "translate(30.855 -895.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2917",
    d: "M63.847 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2917",
    transform: "translate(30.855 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2918",
    d: "M63.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2918",
    transform: "translate(30.855 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2919",
    d: "M63.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2919",
    transform: "translate(30.855 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2920",
    d: "M63.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2920",
    transform: "translate(30.855 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2921",
    d: "M67.347 973.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2921",
    transform: "translate(33.791 -945.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2922",
    d: "M67.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2922",
    transform: "translate(33.791 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2923",
    d: "M67.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2923",
    transform: "translate(33.791 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2924",
    d: "M67.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2924",
    transform: "translate(33.791 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2925",
    d: "M67.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2925",
    transform: "translate(33.791 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2926",
    d: "M67.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2926",
    transform: "translate(33.791 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2927",
    d: "M67.347 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2927",
    transform: "translate(33.791 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2928",
    d: "M67.347 998.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2928",
    transform: "translate(33.791 -925.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2929",
    d: "M67.347 1036.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2929",
    transform: "translate(33.791 -892.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2930",
    d: "M67.347 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2930",
    transform: "translate(33.791 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2931",
    d: "M67.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2931",
    transform: "translate(33.791 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2932",
    d: "M67.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2932",
    transform: "translate(33.791 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2933",
    d: "M70.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2933",
    transform: "translate(36.727 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2934",
    d: "M70.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2934",
    transform: "translate(36.727 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2935",
    d: "M70.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2935",
    transform: "translate(36.727 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2936",
    d: "M70.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2936",
    transform: "translate(36.727 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2937",
    d: "M70.847 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2937",
    transform: "translate(36.727 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2938",
    d: "M70.847 994.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2938",
    transform: "translate(36.727 -928.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2939",
    d: "M70.847 1040.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2939",
    transform: "translate(36.727 -889.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2940",
    d: "M70.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2940",
    transform: "translate(36.727 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2941",
    d: "M70.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2941",
    transform: "translate(36.727 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2942",
    d: "M74.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2942",
    transform: "translate(39.663 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2943",
    d: "M74.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2943",
    transform: "translate(39.663 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2944",
    d: "M74.347 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2944",
    transform: "translate(39.663 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2945",
    d: "M74.347 991.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2945",
    transform: "translate(39.663 -930.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2946",
    d: "M74.347 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2946",
    transform: "translate(39.663 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2947",
    d: "M74.347 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2947",
    transform: "translate(39.663 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2948",
    d: "M77.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2948",
    transform: "translate(42.599 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2949",
    d: "M77.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2949",
    transform: "translate(42.599 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2950",
    d: "M77.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2950",
    transform: "translate(42.599 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2951",
    d: "M77.847 987.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2951",
    transform: "translate(42.599 -933.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2952",
    d: "M77.847 1043.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2952",
    transform: "translate(42.599 -886.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2953",
    d: "M77.847 1047.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2953",
    transform: "translate(42.599 -883.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2954",
    d: "M81.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2954",
    transform: "translate(45.535 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2955",
    d: "M81.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2955",
    transform: "translate(45.535 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2956",
    d: "M81.347 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2956",
    transform: "translate(45.535 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2957",
    d: "M84.847 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2957",
    transform: "translate(48.471 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2958",
    d: "M84.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2958",
    transform: "translate(48.471 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2959",
    d: "M84.847 984.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2959",
    transform: "translate(48.471 -936.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2960",
    d: "M88.347 977.161a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2960",
    transform: "translate(51.407 -942.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2961",
    d: "M88.347 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2961",
    transform: "translate(51.407 -939.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2962",
    d: "M91.847 980.661a2.3 2.3 0 1 1-2.3-2.3 2.3 2.3 0 0 1 2.3 2.3z",
    className: "prefix__cls-1",
    "data-name": "Path 2962",
    transform: "translate(54.343 -939.746)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinnesota);
export default __webpack_public_path__ + "static/media/icon-minnesota.864f52a6f07bdd50b3b893511f808942.svg";
export { ForwardRef as ReactComponent };